/**
 * React dependencies
 */

import React from 'react';

/**
 * DWT Dependencies
 */

const sortOptionsBooks = [
  {
    label: 'Oldest to Newest',
    value: 'onsale',
    direction: 'asc'
  },
  {
    label: 'Newest to Oldest',
    value: 'onsale',
    direction: 'desc'
  },
  {
    label: 'Random',
    value: 'random',
    direction: 'asc'
  },
  {
    label: 'Title: A to Z',
    value: 'title',
    direction: 'asc'
  },
  {
    label: 'Title: Z to A',
    value: 'title',
    direction: 'desc'
  }
];

const sortOptionsContributors = [
  {
    label: 'Last Name: A to Z',
    value: 'authorLast',
    direction: 'asc'
  },
  {
    label: 'Last Name: Z to A',
    value: 'authorLast',
    direction: 'desc'
  },
  {
    label: 'Random',
    value: 'random',
    direction: 'asc'
  }
];

export { sortOptionsBooks, sortOptionsContributors };
